import script from "./shareInstructions.vue?vue&type=script&lang=ts&setup=true"
export * from "./shareInstructions.vue?vue&type=script&lang=ts&setup=true"

import "./shareInstructions.vue?vue&type=style&index=0&id=50bab3a8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50bab3a8"]])

export default __exports__